import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
//import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Table from 'react-bootstrap/Table';
import isMobile from 'ismobilejs';
import './App.css';
const $ = require('jquery');

class App extends React.Component {

  componentDidMount() {
    if (!isMobile().any) {
      const targets = $(".card-header").toArray();
      targets.forEach((element, index) => {
        console.log("targets[" + index + "]: ", element);
        $(element).mouseover(() => {
          if (!$(element).next().hasClass("show")) {
            $(element).trigger("click");
          }
        });
      });
    }
  }

  render() {
    return (
      <div className="container mt-3">
        <h1 className="title">
          NUCT講習会
          <wbr />
          <span className="d-none d-sm-inline">&nbsp;&nbsp;</span>
          <span className="smallLetter">(<a style={{display: 'inline'}} href="/studio/hands-on-workshop-new/">English</a> is also available)</span>
        </h1>
        <Accordion className="mt-3 mb-3">
          <Card>
            <Accordion.Toggle as={Card.Header} variant="link" eventKey="0">
              2020年3月23日緊急講習会「オンライン授業支援ツールの利活用に向けて」
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Accordion defaultActiveKey="0" style={{ marginLeft: "1em", marginTop: "1px" }}>
                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="0" className="scard">
                    緊急講習会(2020/03/23)
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Table bordered hover size="sm" >
                      <tbody>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/4b4036ccb83149f0f4cd4f249b896b0f6348b001/autostart/true/caption/true">NUCT使い方説明1</a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/f94d619abe693b6e3007d384289045ee46d081e3/autostart/true/caption/true">著作権について</a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/f6cb710e9fd3bc2a56fc874dcc8700ddbe491190/autostart/true/caption/true">NUCT使い方説明2</a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/1e752c1cd11d09e4b4e28fc8e6263eda9ca8f404/autostart/true/caption/true">Q&A</a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="./access_to_kinkyu_kosyukai.pdf">緊急講習会資料へのアクセス</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://ct.nagoya-u.ac.jp/access/content/group/2020_1_9900001/緊急講習会スライド.pdf">オンライン授業支援ツールの利活用に向けて</a></td>
                          <td style={{ width: "70%" }}>PDF</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Accordion.Collapse>
          </Card>

          <Card>
            <Accordion.Toggle as={Card.Header} variant="link" eventKey="2">
              鶴舞キャンパス講習会
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Accordion defaultActiveKey="0" style={{ marginLeft: "1em", marginTop: "1px" }}>
                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="0" className="scard">
                    鶴舞キャンパス講習会(2020/03/24)
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Table bordered hover size="sm" >
                      <tbody>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/fc30389c836d9a8102354ce0c43e4c3d17fef33a/autostart/true/caption/true">1. NUCTとは </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/6b2bcbf2967acd2f955b195f681297351725ac07/autostart/true/caption/true">2. 教員による利用編① </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/5e1762ca6a291155e8041b4a00b1a7726ca9e775/autostart/true/caption/true">3. 教員による利用編② </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/43027f23cc534f748980c5b277fded6f2de18109/autostart/true/caption/true">4. 教員による利用編③ </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/03d03499bf955cc0882c607b5db74619696e758d/autostart/true/caption/true">5. 教員による利用編④ </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/8b41a66d874c8a53c3a8358330b1f67fc47cce40/autostart/true/caption/true">6. 練習用NUCT </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>

                      </tbody>
                    </Table>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} variant="link" eventKey="3">
              大幸キャンパス講習会
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              <Accordion defaultActiveKey="0" style={{ marginLeft: "1em", marginTop: "1px" }}>
                <Card>
                  <Accordion.Toggle as={Card.Header} eventKey="0" className="scard">
                    大幸キャンパス講習会(2020/03/26)
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Table bordered hover size="sm" >
                      <tbody>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/0da4ae0786f837a504891c86442bb53c02abf992/autostart/true/caption/true">1. NUCTとは </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/3e8a9891c23a3810c7db03f14525917d2043590d/autostart/true/caption/true">2.教員による利用編① </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/4f2601ad6d2d144e0343d7698781a7bea4b37e76/autostart/true/caption/true">3.教員による利用編②_サイト情報 </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/4b4d9172a70b4063b0fb2b13b0e8102f35775378/autostart/true/caption/true">4.教員による利用編③_お知らせ </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/1e3e00f8a0b51f0ed462ccd909edd33cd6efdc17/autostart/true/caption/true">5.教員による利用編④_リソース </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/a0404c59d3ff99944c6f84e86b7c6d9b60eee193/autostart/true/caption/true">6.教員による利用編⑤_小テスト </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>
                        <tr>
                          <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/792932cd0d424021999edd21799dda4734fddde4/autostart/true/caption/true">7.教員による利用編⑥_課題&その他 </a></td>
                          <td style={{ width: "70%" }}>動画</td>
                        </tr>

                      </tbody>
                    </Table>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} variant="link" eventKey="1">
              NUCTオンデマンド教材（教職員用、受講者用）
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Table bordered hover size="sm" >
                <tbody>
                  <tr>
                    <td><a href="https://media.itc.nagoya-u.ac.jp/studio/ondemand_teaching_materials_guide/">NUCT講習会オンデマンド教材</a></td>
                  </tr>
                </tbody>
              </Table>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} variant="link" eventKey="4">
              English Edition
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
              <div>
                <Table bordered hover size="sm" >
                  <tbody>
                    <tr>
                      <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/90bfe4612e6348477d4bd0a29fba49e1f4de1af8/autostart/true/caption/true">NUCT tutorial for beginners</a></td>
                      <td style={{ width: "70%" }}>Video</td>
                    </tr>
                    <tr>
                      <td style={{ width: "70%" }}><a href="https://media.itc.nagoya-u.ac.jp/studio/NUCT-tutorial-for-beginners.pdf">NUCT tutorial for beginners</a></td>
                      <td style={{ width: "70%" }}>PDF</td>
                    </tr>
                  </tbody>
                </Table>
                <Accordion defaultActiveKey="0" style={{ marginLeft: "1em", marginTop: "1px" }}>
                  <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className="scard">
                      Hand-on Workshop: Online teaching and learning at NU
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                      <Table bordered hover size="sm" >
                        <tbody>
                          <tr>
                            <td colSpan="2" className="mtd">Handout slides</td>
                          </tr>
                          <tr>
                            <Table bordered hover size="sm" >
                              <tbody>
                                <tr>
                                  <td style={{ width: "70%" }}><a href="https://nuvideo.media.nagoya-u.ac.jp/embed/0c96796f40f8553313e733a4e8bac5add47e75bd/autostart/true/caption/true">Online teaching and learning at NU</a></td>
                                  <td style={{ width: "70%" }}>Video</td>
                                </tr>
                                <tr>
                                  <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/Online-teaching-and-learning-at-NU-HLC.pdf">Online teaching and learning at NU</a></td>
                                  <td style={{ width: "70%" }}>PDF</td>
                                </tr>
                                <tr>
                                  <td colSpan="2" className="mtd">Additional guides</td>
                                </tr>
                                <tr>
                                  <td colSpan="2">
                                    <Table bordered hover size="sm">
                                      <tbody>
                                        <tr>
                                          <td style={{ width: "70%" }}><a href="https://www.uhd.edu/computing/services-training/training/Documents/zoom_record_presentations.pdf">Recording Presentations with Zoom</a></td>
                                          <td style={{ width: "70%" }}>PDF</td>
                                        </tr>
                                        <tr>
                                          <td style={{ width: "70%" }}><a href="https://support.office.com/en-us/article/record-a-slide-show-with-narration-and-slide-timings-0b9502c6-5f6c-40ae-b1e7-e47d8741161c">Record a powerpoint slide show with narration and slide timings</a></td>
                                          <td style={{ width: "70%" }}>HTML</td>
                                        </tr>
                                        <tr>
                                          <td style={{ width: "70%" }}><a href="https://support.apple.com/ja-jp/guide/keynote/tan8a5df9cc5/mac">Record audio in Keynote on Mac</a></td>
                                          <td style={{ width: "70%" }}>HTML</td>
                                        </tr>
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </tr>
                          <tr>
                            <td colSpan="2" className="mtd">NUCT Tutorial for Instructor</td>
                          </tr>
                          <Table bordered hover size="sm" >
                            <tbody>
                            <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-1-Summary.pdf">1. Summary</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-2-Site-Info.pdf">2. Site Info</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-3-Announcements.pdf">3. Announcement</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-4-Resources.pdf">4. Resources</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-5-Assignments.pdf">5. Assignments</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-6-Test-Quizzes.pdf">6. Test and Quizzes</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-7-Gradebook.pdf">7. Gradebook</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-instructor-8-Messages.pdf">8. Messages</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                            </tbody>
                          </Table> 
                          <tr>
                            <td colSpan="2" className="mtd">NUCT Tutorial for Students</td>
                          </tr>
                          <Table bordered hover size="sm" >
                            <tbody>
                            <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-1-Summary.pdf">1. Summary</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-2-Site-Info.pdf">2. Site Info</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-3-Announcements.pdf">3. Announcement</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-4-Resources.pdf">4. Resources</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-5-Assignments.pdf">5. Assignments</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-6-Test-Quizzes.pdf">6. Test and Quizzes</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-7-Gradebook.pdf">7. Gradebook</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                              <tr>
                                <td style={{ width: "70%" }}><a href="http://www.ilas.nagoya-u.ac.jp/PDF/NUCT-tutorial-student-8-Messages.pdf">8. Messages</a></td>
                                <td style={{ width: "70%" }}>PDF</td>
                              </tr>
                            </tbody>
                          </Table>
                        </tbody>
                      </Table>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            </Accordion.Collapse>
          </Card>
        </Accordion>
        <div>
          <p className="text-center">PDFの一部は学内からのみ閲覧できるようになっております。また、一部の動画につきまして名大IDの認証が必要になります。</p>
        </div>
      </div>
    );
  }
}
export default App;
